module.exports = __webpack_public_path__ + "img/fi-rr-comment-alt.687b6e2a.svg";